import { render, staticRenderFns } from "./NewCardModal.vue?vue&type=template&id=0851f580&scoped=true&"
import script from "./NewCardModal.vue?vue&type=script&lang=js&"
export * from "./NewCardModal.vue?vue&type=script&lang=js&"
import style0 from "./NewCardModal.vue?vue&type=style&index=0&id=0851f580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851f580",
  null
  
)

export default component.exports